import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { users: () => import('./UsersPage.vue') },
} satisfies FeatureRoutes
